export default __webpack_public_path__ + "static/media/localisation.596b3dbc.png";